/* eslint-disable jsx-a11y/accessible-emoji */
import React from "react";
import {
  BorderContainer,
  Subtitle,
  Container,
  Button,
  MainTitle,
} from "../mainStyles";

const PopupError = () => {
  const _reload = () => {
    window.location.reload("true");
  };
  return (
    <BorderContainer>
      <Container style={{ height: "35rem" }} id="popupError">
        <MainTitle style={{ textAlign: "center" }} id="createNewC">
          Terrible, Terrible Mistake
        </MainTitle>
        <Subtitle style={{ textAlign: "center" }}>
          Uh oh. There’s an error. You will need to reload the page. Let’s hope
          all updates are safe. 😞
        </Subtitle>

        <Button
          style={{ margin: "auto", marginBottom: "0.5rem" }}
          onClick={_reload}
          id="btnReload"
        >
          Reload the page
        </Button>
      </Container>
    </BorderContainer>
  );
};

export default PopupError;
